import React from 'react';
import { 
    EditButton,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateField,
    CardActions,
    ListButton,
    Show,
    SimpleShowLayout
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import LinkToCreate from  '../../controls/LinkToCreate';
import ErrorBoundary from '../../ErrorBoundary';

const useStyles = makeStyles({

    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    inlineBlockLeft: {
        display: 'inline-flex',
        float:    'left', 
        marginRight: '1rem' 
    },
    hidden : {
        display: 'none' 
    },
    inputStyle : {
        width :'20px',
    },
    controlInputStyle : {
       width :'70px',
       fontSize: '8'
   },
    labelStyle : {
       width :'40px',
       backgroundColor: 'silver'
   },
   iniLabelStyle : {
       width :'20px',
       backgroundColor: 'silver'
   },
   dateStyle : {
       width: '120px',
       
   },
   tableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'1px solid  black', 
       width: "100%"
   },
   h3: {
       textAlign: 'center',
       width: '100%'
   },
   clearTableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'0px solid  black', 
       width: "100%"
   },
   inlineBlock: {
       display: 'inline-flex',
       margin: '5px',
       padding: '5px',
   },

});


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CalActions = ({...props}) => (
    <CardActions style={cardActionStyle}>
        <LinkToCreate id={props.filterValues.ins_id} name='Create' path='/cal_MICRO_CENT_d/create' />
        <ListButton basePath={'/calinstrument'} label="Calibration List" />
    </CardActions>
);

const Editable = ({record}) => {
    //console.log(record.editable);
    return record && record.is_qa > 0 ? '' : <EditButton  record={record} label='Update'/> ;
}

const ShowDetails = ({...props}) => {
    const classes = useStyles();
    var days = [];

    //console.log(props.record)
    if(props && props.record && props.record.details){
        try{
          days =JSON.parse(props.record.details) 
        } catch(e) {
          days = props.record.details;
        };
    }

    return(
        <ErrorBoundary>  
        <>
        
            <table className={classes.tableStyle} >
            <tbody  > 
                <tr>
                    <td>
                    <table className={classes.clearTableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan={4} ><center><h3>MICROHEMATOCRIT CENTRIFUGE</h3></center></td>
                            </tr>
                            <tr>
                                <td>Center Name:</td><td><TextField source='center'  label=''  /></td>
                                <td>Month/Year:</td>
                                <td><TextField source='months' label=''  />&nbsp;/&nbsp;
                                    <TextField source='years' label='' />
                                </td>
                            </tr>
                            <tr>
                                <td>Equipment ID:</td><td><TextField source='eq_id'  label='' /></td>
                                <td>Booth:</td><td><TextField source='booth'  label='' /></td>
                            </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                <tr >
                <td>
                    <table className={classes.tableStyle} >
                    <tbody  > 
                            <tr >
                                <td className={classes.labelStyle}>Daily Control</td>
                                <td className={classes.labelStyle}>Normal Control</td>
                                <td className={classes.labelStyle}>Low Control</td>
                                <td className={classes.labelStyle}>High Contorl</td>
                                <td className={classes.iniLabelStyle}>Initial</td>
                                <td className={classes.labelStyle}>Date</td>
                                <td className={classes.iniLabelStyle}>QA Initial</td>
                                <td className={classes.labelStyle}>QA Date</td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Manufacturer</td>
                                    <td className={classes.controlInputStyle} ><TextField source="man_nor"    label="" /></td>
                                    <td className={classes.controlInputStyle} ><TextField source="man_low"    label="" /></td>
                                    <td className={classes.controlInputStyle} ><TextField source="man_high"    label="" /></td>
                                    <td className={classes.inputStyle} ><TextField source="man_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="man_date"    label=""  locales="en-us"   /></td>
                                    <td className={classes.inputStyle} ><TextField source="man_qa_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="man_qa_date"    label="" locales="en-us"  /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Lot Number</td>
                                    <td className={classes.controlInputStyle} ><TextField source="lot_nor"    label="" /></td>
                                    <td className={classes.controlInputStyle} ><TextField source="lot_low"    label="" /></td>
                                    <td className={classes.controlInputStyle} ><TextField source="lot_high"    label="" /></td>
                                    <td className={classes.inputStyle}><TextField source="lot_init"    label="" /></td>
                                    <td className={classes.inputStyle}><DateField source="lot_date"    label=""  locales="en-us"   /></td>
                                    <td className={classes.inputStyle}><TextField source="lot_qa_init"    label="" /></td>
                                    <td className={classes.inputStyle}><DateField source="lot_qa_date"    label=""  locales="en-us" /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Manufaturer expiration</td>
                                    <td className={classes.inputStyle} ><DateField source="man_exp_nor"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><DateField source="man_exp_low"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><DateField source="man_exp_high"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><TextField source="man_exp_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="man_exp_date"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><TextField source="man_exp_qa_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="man_exp_qa_date"    label="" locales="en-us"  /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Range</td>
                                    <td className={classes.controlInputStyle} ><TextField source="rag_nor"    label="" /></td>
                                    <td className={classes.controlInputStyle} ><TextField source="rag_low"    label="" /></td>
                                    <td className={classes.controlInputStyle} ><TextField source="rag_high"    label="" /></td>
                                    <td className={classes.inputStyle} ><TextField source="rag_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="rag_date"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><TextField source="rag_qa_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="rag_qa_date"    label="" locales="en-us"  /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Date vial opened</td>
                                    <td className={classes.controlInputStyle} ><DateField source="vop_nor"    label=""  locales="en-us" /></td>
                                    <td className={classes.controlInputStyle} ><DateField source="vop_low"    label=""  locales="en-us" /></td>
                                    <td className={classes.controlInputStyle} ><DateField source="vop_high"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><TextField source="vop_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="vop_date"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><TextField source="vop_qa_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="vop_qa_date"    label="" locales="en-us"  /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Date vial expires</td>
                                    <td className={classes.controlInputStyle} ><DateField source="vex_nor"    label=""  locales="en-us" /></td>
                                    <td className={classes.controlInputStyle} ><DateField source="vex_low"    label=""  locales="en-us" /></td>
                                    <td className={classes.controlInputStyle} ><DateField source="vex_high"    label=""  locales="en-us" /></td>
                                    <td className={classes.inputStyle} ><TextField source="vex_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="vex_date"    label=""  locales="en-us"  /></td>
                                    <td className={classes.inputStyle} ><TextField source="vex_qa_init"    label="" /></td>
                                    <td className={classes.inputStyle} ><DateField source="vex_qa_date"    label="" locales="en-us"  /></td>
                            </tr>
                            </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr><td >&nbsp;</td></tr>
                    <tr>
                        <td >
                            <table className={classes.tableStyle} >
                                <tbody>
                                <tr>
                                    <td className={classes.labelStyle}>Date</td>
                                    <td className={classes.labelStyle}>Normal %</td>
                                    <td className={classes.labelStyle}>Low %</td>
                                    <td className={classes.labelStyle}>High %</td>
                                    <td className={classes.labelStyle}>Comments %</td>
                                    <td className={classes.labelStyle}>Tech Initial</td>
                                    <td className={classes.labelStyle}>Tech Date</td>
                                    <td className={classes.labelStyle}>QA Initial</td>
                                    <td className={classes.labelStyle}>QA Date</td>
                                    <td className={classes.labelStyle}>QA Approved</td>
                                </tr>
                                {
                                    days && days.map((item, index) =>(
                                    <tr>
                                        <td>{item['dt']}</td>
                                        <td>{item['nor']}</td>
                                        <td>{item['low']}</td>
                                        <td>{item['high']}</td>
                                        <td>{item['commnents']}</td>
                                        <td>{item['t_init']}</td>
                                        <td>{item['t_date']}</td>
                                        <td>{item['q_init']}</td>
                                        <td>{item['q_date']}</td>
                                        <td>{item['is_qa']? 'Yes' : 'No'}</td>
                                    </tr>
                                    )
                                )}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    
                </tbody>
            </table>
            </>
        </ErrorBoundary>  
    )
}


const View= props =>(
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout   >
            <ShowDetails  />    
        </SimpleShowLayout>
    </Show>
);

export const InsList = ({...props }) => (
    <ErrorBoundary>  
    <List 
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<CalActions/>} 
        title ="Calibration | Microhematocrit Centrifuge | Daily"
        >
        <Datagrid  expand={<View  {...props}/>} >
            <TextField source="ins_id" label="Equip ID" />
            <TextField source="month_year_full" label="Month/Year" />
            <Editable />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default InsList;
